"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const eth_1 = require("../config/eth");
const weths_1 = require("../config/contracts/weths");
class OffchainPoolToken {
    // Helpers
    getPoolTokenParam(param) {
        return __awaiter(this, void 0, void 0, function* () {
            const poolTokenData = yield this.getPoolTokenData();
            return poolTokenData[param];
        });
    }
    getPoolTokenParamFloat(param) {
        return __awaiter(this, void 0, void 0, function* () {
            return parseFloat(yield this.getPoolTokenParam(param));
        });
    }
    getPoolTokenParamInt(param) {
        return __awaiter(this, void 0, void 0, function* () {
            return parseInt(yield this.getPoolTokenParam(param));
        });
    }
    getUnderlyingParam(param) {
        return __awaiter(this, void 0, void 0, function* () {
            const poolTokenData = yield this.getPoolTokenData();
            return poolTokenData.underlying[param];
        });
    }
    // Name
    getName() {
        return __awaiter(this, void 0, void 0, function* () {
            const underlying = yield this.getUnderlyingAddress();
            if (underlying.toLowerCase() === weths_1.WETH[this.getOffchain().network].toLowerCase())
                return eth_1.ETH_NAME[this.getOffchain().network];
            if (underlying.toLowerCase() === "0xa3fa99a148fa48d14ed51d610c367c61876997f1")
                return "MIMATIC";
            if (underlying.toLowerCase() === "0x2e9a6df78e42a30712c10a9dc4b1c8656f8f2879")
                return "Maker";
            return this.getUnderlyingParam("name");
        });
    }
    // Symbol
    getSymbol() {
        return __awaiter(this, void 0, void 0, function* () {
            const underlying = yield this.getUnderlyingAddress();
            if (underlying.toLowerCase() === weths_1.WETH[this.getOffchain().network].toLowerCase())
                return eth_1.ETH_SYMBOL[this.getOffchain().network];
            if (underlying.toLowerCase() === "0xa3fa99a148fa48d14ed51d610c367c61876997f1")
                return "MAI";
            if (underlying.toLowerCase() === "0x2e9a6df78e42a30712c10a9dc4b1c8656f8f2879")
                return "MKR";
            if (underlying.toLowerCase() === "0xc165d941481e68696f43ee6e99bfb2b23e0e3114")
                return "OXDv1";
            if (underlying.toLowerCase() === "0xc5a9848b9d145965d821aaec8fa32aaee026492d")
                return "OXDv2";
            if (underlying.toLowerCase() === "0x6ae7dfc73e0dde2aa99ac063dcf7e8a63265108c")
                return "JPYCv1";
            if (underlying.toLowerCase() === "0x431d5dff03120afa4bdf332c61a6e1766ef37bdb")
                return "JPYCv2";
            if (underlying.toLowerCase() === "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8")
                return "USDC.e";
            return this.getUnderlyingParam("symbol");
        });
    }
    // Decimals
    getDecimals() {
        return __awaiter(this, void 0, void 0, function* () {
            return parseInt(yield this.getUnderlyingParam("decimals"));
        });
    }
    // ExchangeRate
    getExchangeRate() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getPoolTokenParamFloat("exchangeRate");
        });
    }
    // Underlying Address
    getUnderlyingAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getUnderlyingParam("id");
        });
    }
    // Total balance
    getTotalBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getPoolTokenParamFloat("totalBalance");
        });
    }
    getTotalBalanceUSD() {
        return __awaiter(this, void 0, void 0, function* () {
            const totalBalance = yield this.getTotalBalance();
            const tokenPrice = yield this.getTokenPriceFast();
            return totalBalance * tokenPrice;
        });
    }
    // Calculate collateral price -> returns the price of the collateral, not necessarily of the underlying LP
    // TODO refactor?
    calculateCollateralPrice(reserve0, reserve1, totalSupply, price0, price1) {
        if (totalSupply === 0) {
            console.error("Warning: totalSupply is 0");
            return 0;
        }
        const reserve0USD = reserve0 * price0;
        const reserve1USD = reserve1 * price1;
        // adjust reserves taking the latest price passed as parameters
        const adjustedReserveUSD = Math.sqrt(reserve0USD * reserve1USD) * 2;
        return adjustedReserveUSD / totalSupply;
    }
    // Token price getters
    getTokenPriceFast(fallback = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (fallback) {
                return this.getTokenPriceAccurate();
            }
            return 0;
        });
    }
}
exports.default = OffchainPoolToken;
